var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"mapbox-map",style:({ height: typeof _vm.height === 'string' ? _vm.height : (_vm.height + "px") })})}
var staticRenderFns = []

export { render, staticRenderFns }